if (!customElements.get('size-choice')) {
  customElements.define(
    'size-choice',
    class SizeChoice extends HTMLElement {
      // Dawn opens every product on its first available variant, so a shopper
      // who never touches the size buttons gets the smallest size. Until a
      // choice is made here, the options with more than one value show no
      // selection, the button asks for a size, and a tap on it points to the
      // picker instead of adding a size nobody chose. A link with ?variant=
      // counts as a choice.
      connectedCallback() {
        this.info = this.closest('product-info');
        this.form = this.info?.querySelector('product-form');
        this.selects = this.info?.querySelector('variant-selects');
        if (!this.info || !this.form || !this.selects) return;
        if (new URLSearchParams(window.location.search).has('variant') && !this.closest('quick-add-modal')) return;

        this.groups = this.openGroups();
        if (!this.groups.length) return;

        this.pending = true;
        this.groups.forEach((group) => this.clear(group));
        this.setButtonLabel();

        this.onChange = (event) => {
          if (!this.pending || !this.selects.contains(event.target)) return;
          this.pending = false;
          this.clearHint();
        };
        this.onSubmit = (event) => {
          if (!this.pending) return;
          event.preventDefault();
          event.stopPropagation();
          this.showHint();
        };
        this.info.addEventListener('change', this.onChange, true);
        this.form.addEventListener('submit', this.onSubmit, true);
      }

      disconnectedCallback() {
        this.info?.removeEventListener('change', this.onChange, true);
        this.form?.removeEventListener('submit', this.onSubmit, true);
      }

      openGroups() {
        const fieldsets = [...this.selects.querySelectorAll('fieldset')].filter(
          (fieldset) => fieldset.querySelectorAll('input[type="radio"]').length > 1
        );
        const dropdowns = [...this.selects.querySelectorAll('select')].filter((select) => select.options.length > 1);
        return [...fieldsets, ...dropdowns];
      }

      name(group) {
        const raw =
          group.tagName === 'SELECT'
            ? group.closest('.product-form__input')?.querySelector('label')?.textContent
            : group.querySelector('legend')?.textContent;
        return (raw || '').trim().replace(/:.*$/, '').toLowerCase() || 'størrelse';
      }

      clear(group) {
        if (group.tagName === 'SELECT') {
          [...group.options].forEach((option) => option.removeAttribute('selected'));
          const placeholder = new Option(`Vælg ${this.name(group)}`, '', true, true);
          placeholder.disabled = true;
          placeholder.setAttribute('selected', 'selected');
          group.prepend(placeholder);
          return;
        }
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
          input.removeAttribute('checked');
        });
      }

      label() {
        const names = [...new Set(this.groups.map((group) => this.name(group)))];
        return `Vælg ${names.join(' og ')}`;
      }

      // The sticky bar copies this text, so it asks for a size too.
      setButtonLabel() {
        const text = this.form.querySelector('[type="submit"] span');
        if (text && !this.form.querySelector('[type="submit"]').disabled) text.textContent = this.label();
      }

      showHint() {
        this.clearHint();
        this.groups.forEach((group) => group.classList.add('is-missing'));
        const first = this.groups[0];
        const hint = document.createElement('p');
        hint.className = 'size-choice__hint';
        hint.setAttribute('role', 'alert');
        hint.textContent = `${this.label()} først`;
        (first.tagName === 'SELECT' ? first.closest('.product-form__input') : first).append(hint);

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        first.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        const target = first.tagName === 'SELECT' ? first : first.querySelector('input:not(:disabled)');
        target?.focus({ preventScroll: true });
      }

      clearHint() {
        this.info.querySelectorAll('.size-choice__hint').forEach((hint) => hint.remove());
        this.groups.forEach((group) => group.classList.remove('is-missing'));
      }
    }
  );
}
